(function () {
	'use strict';

	var header = document.getElementById('siteHeader');
	var scrollTopBtn = document.getElementById('scrollTopBtn');
	var promoBar = document.querySelector('.ps-promo-bar');

	function updateHeaderOffset() {
		var offset = 0;
		if (promoBar && !promoBar.classList.contains('is-hidden')) {
			offset = promoBar.offsetHeight;
		}
		document.documentElement.style.setProperty('--ps-header-offset', offset + 'px');
	}

	/* Promo bar dismiss */
	if (promoBar) {
		var dismissBtn = promoBar.querySelector('[data-promo-dismiss]');
		if (dismissBtn && sessionStorage.getItem('ps_promo_dismissed_closing_v1') === '1') {
			promoBar.classList.add('is-hidden');
		}
		if (dismissBtn) {
			dismissBtn.addEventListener('click', function () {
				promoBar.classList.add('is-hidden');
				sessionStorage.setItem('ps_promo_dismissed_closing_v1', '1');
				updateHeaderOffset();
			});
		}
		updateHeaderOffset();
		window.addEventListener('resize', updateHeaderOffset);

		if (typeof ResizeObserver !== 'undefined') {
			var promoObserver = new ResizeObserver(updateHeaderOffset);
			promoObserver.observe(promoBar);
		}
	}

	/* New location popup */
	var locationPopup = document.getElementById('newLocationPopup');
	if (locationPopup) {
		var locationPopupStorageKey = 'ps_closed_popup_dismissed_v1';
		var locationPopupDismissed = false;
		var locationPopupPreviousFocus = null;

		try {
			locationPopupDismissed = sessionStorage.getItem(locationPopupStorageKey) === '1';
		} catch (error) {
			locationPopupDismissed = false;
		}

		function dismissLocationPopup() {
			locationPopup.classList.remove('is-visible');
			locationPopup.setAttribute('aria-hidden', 'true');
			document.body.classList.remove('ps-go-popup-open');

			try {
				sessionStorage.setItem(locationPopupStorageKey, '1');
			} catch (error) {
				// The popup still closes when browser storage is unavailable.
			}

			if (locationPopupPreviousFocus) {
				locationPopupPreviousFocus.focus();
			}
		}

		function openLocationPopup() {
			locationPopupPreviousFocus = document.activeElement;
			locationPopup.classList.add('is-visible');
			locationPopup.setAttribute('aria-hidden', 'false');
			document.body.classList.add('ps-go-popup-open');

			var closeButton = locationPopup.querySelector('.ps-go-popup__close');
			if (closeButton) {
				closeButton.focus();
			}
		}

		locationPopup.querySelectorAll('[data-go-popup-dismiss]').forEach(function (element) {
			element.addEventListener('click', dismissLocationPopup);
		});

		var locationOrderLink = locationPopup.querySelector('[data-go-popup-order]');
		if (locationOrderLink) {
			locationOrderLink.addEventListener('click', function () {
				try {
					sessionStorage.setItem(locationPopupStorageKey, '1');
				} catch (error) {
					// Navigation should continue when browser storage is unavailable.
				}
			});
		}

		locationPopup.addEventListener('keydown', function (event) {
			if (event.key === 'Escape') {
				dismissLocationPopup();
				return;
			}

			if (event.key !== 'Tab') {
				return;
			}

			var focusable = locationPopup.querySelectorAll('a[href], button:not([disabled])');
			if (!focusable.length) {
				return;
			}

			var firstFocusable = focusable[0];
			var lastFocusable = focusable[focusable.length - 1];
			if (event.shiftKey && document.activeElement === firstFocusable) {
				event.preventDefault();
				lastFocusable.focus();
			} else if (!event.shiftKey && document.activeElement === lastFocusable) {
				event.preventDefault();
				firstFocusable.focus();
			}
		});

		if (!locationPopupDismissed) {
			openLocationPopup();
		}
	}

	/* Header scroll state */
	function onScroll() {
		var y = window.scrollY || window.pageYOffset;

		if (header) {
			if (y > 60) {
				header.classList.add('is-scrolled');
			} else {
				header.classList.remove('is-scrolled');
			}
		}

		if (scrollTopBtn) {
			if (y > 400) {
				scrollTopBtn.classList.add('is-visible');
			} else {
				scrollTopBtn.classList.remove('is-visible');
			}
		}
	}

	window.addEventListener('scroll', onScroll, { passive: true });
	onScroll();

	if (scrollTopBtn) {
		scrollTopBtn.addEventListener('click', function () {
			window.scrollTo({ top: 0, behavior: 'smooth' });
		});
	}

	/* Reviews swiper */
	var reviewsEl = document.querySelector('.ps-reviews-swiper');
	if (reviewsEl && typeof Swiper !== 'undefined') {
		new Swiper(reviewsEl, {
			slidesPerView: 1,
			spaceBetween: 24,
			loop: true,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false
			},
			pagination: {
				el: '.ps-reviews-pagination',
				clickable: true
			},
			breakpoints: {
				768: { slidesPerView: 2 },
				992: { slidesPerView: 3 }
			}
		});
	}

	/* Signature pizzas swiper (mobile) */
	var pizzasEl = document.querySelector('.ps-pizzas-swiper');
	if (pizzasEl && typeof Swiper !== 'undefined') {
		new Swiper(pizzasEl, {
			slidesPerView: 1.15,
			spaceBetween: 16,
			pagination: {
				el: '.ps-pizzas-pagination',
				clickable: true
			},
			breakpoints: {
				576: { slidesPerView: 1.5 },
				768: { enabled: false }
			}
		});
	}

	/* Loading state for shop / checkout buttons */
	function setButtonLoading(btn, loadingText) {
		if (!btn || btn.classList.contains('is-loading')) {
			return;
		}

		if (!btn.dataset.psOriginalHtml) {
			btn.dataset.psOriginalHtml = btn.innerHTML;
		}

		var text = loadingText || btn.dataset.psLoadingText || 'Please wait…';
		btn.classList.add('is-loading');
		btn.setAttribute('aria-busy', 'true');

		if (btn.tagName === 'BUTTON' || btn.tagName === 'INPUT') {
			btn.disabled = true;
		} else {
			btn.setAttribute('aria-disabled', 'true');
			btn.style.pointerEvents = 'none';
		}

		btn.innerHTML = '<span class="ps-btn__spinner" aria-hidden="true"></span>' + text;
	}

	function resetButtonLoading(btn) {
		if (!btn || !btn.classList.contains('is-loading')) {
			return;
		}

		btn.classList.remove('is-loading');
		btn.removeAttribute('aria-busy');

		if (btn.tagName === 'BUTTON' || btn.tagName === 'INPUT') {
			btn.disabled = false;
		} else {
			btn.removeAttribute('aria-disabled');
			btn.style.pointerEvents = '';
		}

		if (btn.dataset.psOriginalHtml) {
			btn.innerHTML = btn.dataset.psOriginalHtml;
		}
	}

	function bindLoadingForms() {
		document.querySelectorAll('[data-ps-loading-form]').forEach(function (form) {
			form.addEventListener('submit', function (event) {
				var btn = form.querySelector('[type="submit"][data-ps-loading], [data-ps-loading-submit]');

				if (!btn || btn.disabled || btn.classList.contains('is-loading')) {
					return;
				}

				if (!form.checkValidity || form.checkValidity()) {
					var loadingText = btn.dataset.psLoadingText;
					setTimeout(function () {
						if (!event.defaultPrevented) {
							setButtonLoading(btn, loadingText);
						}
					}, 0);
				}
			});
		});
	}

	function bindLoadingLinks() {
		document.querySelectorAll('[data-ps-loading-link]').forEach(function (link) {
			link.addEventListener('click', function () {
				if (link.classList.contains('is-loading')) {
					return;
				}

				setButtonLoading(link);
			});
		});
	}

	window.PsButtonLoading = {
		set: setButtonLoading,
		reset: resetButtonLoading,
	};

	/* Basket promo code + inline login/register */
	var promoForm = document.getElementById('psPromoForm');
	if (promoForm) {
		var promoMsg = document.getElementById('psPromoMsg');
		var authModal = document.getElementById('psAuthModal');

		function postForm(url, form) {
			return fetch(url, {
				method: 'POST',
				headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
				credentials: 'same-origin',
				body: new FormData(form),
			}).then(function (response) {
				return response.json().catch(function () { return {}; }).then(function (json) {
					return { ok: response.ok, data: json };
				});
			});
		}

		function showPromoMsg(message) {
			if (!promoMsg) { return; }
			promoMsg.textContent = message || '';
			promoMsg.classList.toggle('d-none', !message);
		}

		function applyPromo() {
			return postForm(promoForm.getAttribute('action'), promoForm);
		}

		function openAuthModal() {
			if (!authModal) { return; }
			authModal.classList.add('is-visible');
			authModal.setAttribute('aria-hidden', 'false');
			document.body.classList.add('ps-modal-open');
			var firstInput = authModal.querySelector('.ps-auth-form:not(.d-none) input');
			if (firstInput) { firstInput.focus(); }
		}

		function closeAuthModal() {
			if (!authModal) { return; }
			authModal.classList.remove('is-visible');
			authModal.setAttribute('aria-hidden', 'true');
			document.body.classList.remove('ps-modal-open');
		}

		promoForm.addEventListener('submit', function (event) {
			event.preventDefault();
			showPromoMsg('');
			applyPromo().then(function (res) {
				if (res.data && res.data.success) { window.location.reload(); return; }
				if (res.data && res.data.login_required) { openAuthModal(); return; }
				showPromoMsg((res.data && res.data.message) || 'Could not apply that code.');
			}).catch(function () {
				showPromoMsg('Something went wrong. Please try again.');
			});
		});

		if (authModal) {
			authModal.querySelectorAll('[data-auth-close]').forEach(function (btn) {
				btn.addEventListener('click', closeAuthModal);
			});

			var tabs = authModal.querySelectorAll('[data-auth-tab]');
			var panels = authModal.querySelectorAll('[data-auth-panel]');
			tabs.forEach(function (tab) {
				tab.addEventListener('click', function () {
					var name = tab.getAttribute('data-auth-tab');
					tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
					panels.forEach(function (panel) {
						panel.classList.toggle('d-none', panel.getAttribute('data-auth-panel') !== name);
					});
					var firstInput = authModal.querySelector('.ps-auth-form:not(.d-none) input');
					if (firstInput) { firstInput.focus(); }
				});
			});

			document.addEventListener('keydown', function (event) {
				if (event.key === 'Escape' && authModal.classList.contains('is-visible')) {
					closeAuthModal();
				}
			});

			function bindAuthForm(form) {
				if (!form) { return; }
				form.addEventListener('submit', function (event) {
					event.preventDefault();
					var msgEl = form.querySelector('[data-auth-msg]');
					var submitBtn = form.querySelector('button[type="submit"]');
					if (msgEl) { msgEl.textContent = ''; msgEl.classList.add('d-none'); }
					if (submitBtn) { submitBtn.disabled = true; }

					postForm(form.getAttribute('data-action'), form).then(function (res) {
						if (res.data && res.data.success) {
							applyPromo().then(function () { window.location.reload(); })
								.catch(function () { window.location.reload(); });
							return;
						}
						if (submitBtn) { submitBtn.disabled = false; }
						if (msgEl) {
							msgEl.textContent = (res.data && res.data.message) || 'Please check your details and try again.';
							msgEl.classList.remove('d-none');
						}
					}).catch(function () {
						if (submitBtn) { submitBtn.disabled = false; }
						if (msgEl) {
							msgEl.textContent = 'Something went wrong. Please try again.';
							msgEl.classList.remove('d-none');
						}
					});
				});
			}

			bindAuthForm(document.getElementById('psLoginForm'));
			bindAuthForm(document.getElementById('psRegisterForm'));
		}
	}

	bindLoadingForms();
	bindLoadingLinks();
})();
